
import { Grid, Typography, Box, TextField, IconButton, InputAdornment, Checkbox, FormControlLabel, Link, Button, FormHelperText, CircularProgress, } from "@mui/material";
import styleCss from "../Style/style";
import DataIcon from "../img/dataicon.png"
import { useState } from "react";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import GoogleImg from "../img/googleIcon.png"
import FacebookImg from "../img/facbookicon.png"
import { useFormik } from "formik";
import * as Yup from 'yup';
import { useDispatch } from "react-redux";
import { AuthRegister, AuthSocialLogin } from "../ReduxStore/authSlice";
import showToast from "../Utilities/showToast";
import { useNavigate } from "react-router-dom";
import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";
import { useGoogleLogin } from "@react-oauth/google";
import axios from "axios";


const Signup = ({ facebookClientId }) => {
    //const facebookClientId = process.env.REACT_FACEBOOK_APP_ID;
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);

    const RegisterForm = useFormik({
        enableReinitialize: true,
        initialValues: {
            first_name: "",
            last_name: "",
            mobile: "",
            email: "",
            password: "",
            term_policy: false
        },
        validationSchema: Yup.object({
            first_name: Yup.string().required('Enter the first name'),
            last_name: Yup.string().required('Enter the last name'),
            mobile: Yup.string()
                .matches(/^[0-9]{10,15}$/, "Mobile number must be valid (10 to 15 digits)")
                .min(10, "Mobile number must be at least 10 digits")
                .max(10, "Mobile number cannot be longer than 15 digits")
                .required("Enter valid mobile number"),
            email: Yup.string()
                .email('Enter the email id properly')
                .required('Enter the email id'),
            password: Yup.string()
                .required('Enter the password'),
            term_policy: Yup.boolean()
                .oneOf([true], 'You must accept the term and policy')
                .required('You must accept the term and policy'),

        }), validateOnChange: true,
        validateOnBlur: true,
        onSubmit: async (values) => {
            setLoading(true)
            const { payload: response } = await dispatch(AuthRegister({
                values
            }))
            setLoading(false)
            if (response?.status) {
                showToast('success', response?.message)
                navigate('/')

            } else {
                showToast('error', response?.message)
            }
        }

    })

    const [showPassword, setShowPassword] = useState(false);
    const handleToggle = () => setShowPassword(!showPassword);


    const handleFacebookSuccess = async (response) => {
        const { payload: apiResponse } = await dispatch(AuthSocialLogin({
            login_type: 2, email: response.email, first_name: response.name
        }))
        if (apiResponse?.status) {
            showToast('success', apiResponse?.message)
            navigate('/')

        } else {
            showToast('error', apiResponse?.message)
        }
    }


    const handleGoogleLogin = useGoogleLogin({
        onSuccess: async (response) => {
            try {
                const userInfo = await axios.get(
                    "https://www.googleapis.com/oauth2/v3/userinfo",
                    {
                        headers: { Authorization: `Bearer ${response.access_token}` },
                    }
                );
                const { payload: apiResponse } = await dispatch(AuthSocialLogin({
                    login_type: 1, email: userInfo.data.email, first_name: userInfo.data.given_name
                }))
                if (apiResponse?.status) {
                    showToast('success', apiResponse?.message)
                    navigate('/')

                } else {
                    showToast('error', apiResponse?.message)
                }

            } catch (error) {
                showToast('error', error?.message)
            }
        },
        onError: () => {
          return 2;
        },
    })

    return (<>
        <Box>
            <form onSubmit={RegisterForm.handleSubmit}>
                <Grid container spacing={2}>
                    <Grid size={{ md: 6, xs: 12 }}>
                        <Typography sx={styleCss.CommonLabelName}>First Name:</Typography>
                        <TextField
                            name="first_name"
                            onChange={RegisterForm.handleChange}
                            value={RegisterForm.values.first_name}
                            error={RegisterForm.touched.first_name && Boolean(RegisterForm.errors.first_name)}
                            // helperText={RegisterForm.touched.first_name && RegisterForm.errors.first_name}
                            // FormHelperTextProps={{
                            //     component: 'span',
                            // }}
                            variant="outlined"
                            size="small"
                            placeholder="First Name"
                            fullWidth
                            sx={{
                                "& .MuiOutlinedInput-root": {
                                    backgroundColor: "#f3f3f5",
                                    borderRadius: "8px",
                                    minHeight: "32px",
                                    padding: 0,
                                    "& input": {
                                        padding: "12px 10px",
                                        fontSize: "13px",
                                        "&::placeholder": {
                                            fontSize: "13px",
                                            color: "#717182",
                                            opacity: 1,
                                            fontFamily: "Segoe UI",
                                        },
                                    },
                                    "& fieldset": { borderColor: "#ddd" },
                                    "&:hover fieldset": { borderColor: "#bbb" },
                                    "&.Mui-focused fieldset": { borderColor: "transparent" },
                                },
                                "& .MuiInputLabel-root": {
                                    fontFamily: "Segoe UI",
                                    fontSize: "14px",
                                    color: "#364252",
                                },
                            }}
                        />

                    </Grid>
                    <Grid size={{ md: 6, xs: 12 }}>
                        <Typography sx={styleCss.CommonLabelName}>last Name:</Typography>
                        <TextField
                            name="last_name"
                            onChange={RegisterForm.handleChange}
                            value={RegisterForm.values.last_name}
                            error={RegisterForm.touched.last_name && Boolean(RegisterForm.errors.last_name)}
                            // helperText={RegisterForm.touched.last_name && RegisterForm.errors.last_name}
                            // FormHelperTextProps={{
                            //     component: 'span',
                            // }}
                            variant="outlined"
                            size="small"
                            placeholder="last Name"
                            fullWidth
                            sx={{
                                "& .MuiOutlinedInput-root": {
                                    backgroundColor: "#f3f3f5",
                                    borderRadius: "8px",
                                    minHeight: "32px",
                                    padding: 0,
                                    "& input": {
                                        padding: "12px 10px",
                                        fontSize: "13px",
                                        "&::placeholder": {
                                            fontSize: "13px",
                                            color: "#717182",
                                            opacity: 1,
                                            fontFamily: "Segoe UI",
                                        },
                                    },
                                    "& fieldset": { borderColor: "#ddd" },
                                    "&:hover fieldset": { borderColor: "#bbb" },
                                    "&.Mui-focused fieldset": { borderColor: "transparent" },
                                },
                                "& .MuiInputLabel-root": {
                                    fontFamily: "Segoe UI",
                                    fontSize: "14px",
                                    color: "#364252",
                                },
                            }}
                        />

                    </Grid>
                    <Grid size={{ md: 12, xs: 12 }}>
                        <Typography sx={styleCss.CommonLabelName}>Email Address:</Typography>
                        <TextField
                            name="email"
                            onChange={RegisterForm.handleChange}
                            value={RegisterForm.values.email}
                            error={RegisterForm.touched.email && Boolean(RegisterForm.errors.email)}
                            // helperText={RegisterForm.touched.email && RegisterForm.errors.email}
                            // FormHelperTextProps={{
                            //     component: 'span',
                            // }}
                            variant="outlined"
                            size="small"
                            placeholder="Email Address"
                            fullWidth
                            sx={{
                                "& .MuiOutlinedInput-root": {
                                    backgroundColor: "#f3f3f5",
                                    borderRadius: "8px",
                                    minHeight: "32px",
                                    padding: 0,
                                    "& input": {
                                        padding: "12px 10px",
                                        fontSize: "13px",
                                        "&::placeholder": {
                                            fontSize: "13px",
                                            color: "#717182",
                                            opacity: 1,
                                            fontFamily: "Segoe UI",
                                        },
                                    },
                                    "& fieldset": { borderColor: "#ddd" },
                                    "&:hover fieldset": { borderColor: "#bbb" },
                                    "&.Mui-focused fieldset": { borderColor: "transparent" },
                                },
                                "& .MuiInputLabel-root": {
                                    fontFamily: "Segoe UI",
                                    fontSize: "14px",
                                    color: "#364252",
                                },
                            }}
                        />

                    </Grid>
                    <Grid size={{ md: 12, xs: 12 }}>
                        <Typography sx={styleCss.CommonLabelName}>Mobile Number:</Typography>
                        <TextField
                            name="mobile"
                            onChange={RegisterForm.handleChange}
                            value={RegisterForm.values.mobile}
                            error={RegisterForm.touched.mobile && Boolean(RegisterForm.errors.mobile)}
                            // helperText={RegisterForm.touched.mobile && RegisterForm.errors.mobile}
                            // FormHelperTextProps={{
                            //     component: 'span',
                            // }}
                            variant="outlined"
                            size="small"
                            placeholder="Enter mobile number"
                            fullWidth
                            sx={{
                                "& .MuiOutlinedInput-root": {
                                    backgroundColor: "#f3f3f5",
                                    borderRadius: "8px",
                                    minHeight: "32px",
                                    padding: 0,
                                    "& input": {
                                        padding: "12px 10px",
                                        fontSize: "13px",
                                        "&::placeholder": {
                                            fontSize: "13px",
                                            color: "#717182",
                                            opacity: 1,
                                            fontFamily: "Segoe UI",
                                        },
                                    },
                                    "& fieldset": { borderColor: "#ddd" },
                                    "&:hover fieldset": { borderColor: "#bbb" },
                                    "&.Mui-focused fieldset": { borderColor: "transparent" },
                                },
                                "& .MuiInputLabel-root": {
                                    fontFamily: "Segoe UI",
                                    fontSize: "14px",
                                    color: "#364252",
                                },
                            }}
                        />

                    </Grid>
                    <Grid size={{ md: 12, xs: 12 }}>
                        <Typography sx={styleCss.CommonLabelName}>Password</Typography>
                        <TextField
                            name="password"
                            onChange={RegisterForm.handleChange}
                            value={RegisterForm.values.password}
                            error={RegisterForm.touched.password && Boolean(RegisterForm.errors.password)}
                            // helperText={RegisterForm.touched.password && RegisterForm.errors.password}
                            // FormHelperTextProps={{
                            //     component: 'span',
                            // }}
                            variant="outlined"
                            size="small"
                            type={showPassword ? "text" : "password"}
                            placeholder="Enter your password"
                            fullWidth
                            sx={{
                                "& .MuiOutlinedInput-root": {
                                    backgroundColor: "#f3f3f5",
                                    borderRadius: "8px",
                                    minHeight: "32px",
                                    padding: 0,
                                    "& input": {
                                        padding: "12px 10px",
                                        fontSize: "13px",
                                        "&::placeholder": {
                                            fontSize: "13px",
                                            color: "#717182",
                                            opacity: 1,
                                            fontFamily: "Segoe UI",
                                        },
                                    },
                                    "& fieldset": { borderColor: "#ddd" },
                                    "&:hover fieldset": { borderColor: "#bbb" },
                                    "&.Mui-focused fieldset": { borderColor: "transparent" },
                                },
                                "& .MuiInputLabel-root": {
                                    fontFamily: "Segoe UI",
                                    fontSize: "14px",
                                    color: "#364252",
                                },
                            }}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton onClick={handleToggle} edge="end" sx={{ marginRight: 'unset' }}>
                                            {showPassword ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                        />

                    </Grid>
                    <Grid size={{ md: 12, xs: 12 }}>
                        <FormControlLabel
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                fontFamily: "Segoe UI",
                            }}
                            control={
                                <Checkbox
                                    name="term_policy"
                                    onChange={RegisterForm.handleChange}
                                    checked={RegisterForm.values.term_policy}
                                    sx={{
                                        color: "#1d3557",
                                        "&.Mui-checked": { color: "#1d3557" },
                                        padding: "0px 0px 0px 10px",
                                    }}
                                />
                            }
                            label={
                                <Typography
                                    component="span"
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "3px",
                                        fontFamily: "Segoe UI",
                                        fontSize: "13px",
                                        fontWeight: "normal",
                                        color: "#030213",
                                        whiteSpace: "nowrap",
                                        cursor: "pointer",
                                    }}
                                >
                                    I agree to the
                                    <Link
                                        href="#"
                                        underline="none"
                                        sx={{ color: "#ff5714", fontWeight: 500, fontSize: "13px" }}
                                    >
                                        Terms & Conditions
                                    </Link>
                                    and
                                    <Link
                                        href="#"
                                        underline="none"
                                        sx={{ color: "#ff5714", fontWeight: 500, fontSize: "13px" }}
                                    >
                                        Privacy Policy
                                    </Link>
                                </Typography>
                            }
                        />
                        {RegisterForm.touched.term_policy && RegisterForm.errors.term_policy && (
                            <FormHelperText error sx={{ marginLeft: "40px" }}>
                                {RegisterForm.errors.term_policy}
                            </FormHelperText>
                        )}

                    </Grid>
                    <Grid size={{ md: 12, xs: 12 }}>
                        <Button type="submit" variant="contained" sx={{
                            borderRadius: "8px",
                            boxShadow: "0 4px 100px 0 rgba(0, 0, 0, 0.08)",
                            backgroundColor: "#ff5714",
                            fontFamily: "Segoe UI",
                            fontSize: "15px",
                            fontWeight: "500",
                            fontStretch: "normal",
                            fontStyle: "normal",
                            lineHeight: "normal",
                            letterSpacing: "normal",
                            textAlign: "left",
                            color: "#fff",
                            textTransform: "none",
                            width: '100%',
                            padding: '10px 16px',
                            "&:hover": {
                                backgroundColor: "#e64e12",
                                boxShadow: "0 6px 120px 0 rgba(0, 0, 0, 0.12)",
                            },
                        }}> {loading ? (
                            <CircularProgress size={20} color="inherit" />
                        ) : (
                            "Login"
                        )}</Button>
                    </Grid>
                    <Grid size={{ md: 12, xs: 12 }}>
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                width: "100%",
                                gap: 1.5,
                            }}
                        >
                            <Box
                                sx={{
                                    flex: 1,
                                    height: "1px",
                                    backgroundColor: "#e0e0e0",
                                }}
                            />
                            <Typography
                                sx={{
                                    fontFamily: "Segoe UI",
                                    fontSize: "14px",
                                    fontWeight: "normal",
                                    color: "#717182",
                                    whiteSpace: "nowrap",
                                }}
                            >
                                Or continue with
                            </Typography>
                            <Box
                                sx={{
                                    flex: 1,
                                    height: "1px",
                                    backgroundColor: "#e0e0e0",
                                }}
                            />
                        </Box>
                    </Grid>
                    <Grid size={{ md: 6, xs: 12 }}>
                        <Button
                            variant="contained"
                            onClick={handleGoogleLogin}
                            sx={{
                                padding: "10px",
                                borderRadius: "8px",
                                backgroundColor: "#f3f3f5",
                                fontFamily: "Segoe UI",
                                fontSize: "15px",
                                fontWeight: "normal",
                                textAlign: "center",
                                color: "#717182",
                                textTransform: "capitalize",
                                width: "100%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: "8px",
                                boxShadow: "none",
                                "&:hover": {
                                    backgroundColor: "#e9e9eb",
                                    boxShadow: "none",
                                },
                            }}
                        >
                            <Box
                                component="img"
                                src={GoogleImg}
                                alt="Google"
                                sx={{
                                    width: 20,
                                    height: 20,
                                }}
                            />
                            Google
                        </Button>
                    </Grid>
                    <Grid size={{ md: 6, xs: 12 }}>
                        <FacebookLogin
                            appId={facebookClientId}
                            autoLoad={false}
                            fields="name,email,picture"
                            scope="public_profile,email"
                            callback={handleFacebookSuccess}
                            //onSuccess={handleFacebookSuccess}
                            //onFail={handleFacebookFailure}
                            render={({ onClick }) => (
                                <Button
                                    onClick={onClick}
                                    variant="contained"
                                    sx={{
                                        padding: "10px",
                                        borderRadius: "8px",
                                        backgroundColor: "#f3f3f5",
                                        fontFamily: "Segoe UI",
                                        fontSize: "15px",
                                        fontWeight: "normal",
                                        textAlign: "center",
                                        color: "#717182",
                                        textTransform: "capitalize",
                                        width: "100%",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        gap: "8px",
                                        boxShadow: "none",
                                        "&:hover": {
                                            backgroundColor: "#e9e9eb",
                                            boxShadow: "none",
                                        },
                                    }}
                                >
                                    <Box
                                        component="img"
                                        src={FacebookImg}
                                        alt="Google"
                                        sx={{
                                            width: 20,
                                            height: 20,
                                        }}
                                    />
                                    Facebook
                                </Button>)} />
                    </Grid>
                    <Grid size={{ md: 12, xs: 12 }}>
                        <Typography sx={{
                            fontFamily: "Segoe UI",
                            fontSize: "15px",
                            fontWeight: "normal",
                            textAlign: "center",
                            color: "#717182",
                            textTransform: "capitalize",
                        }}><img src={DataIcon} alt="" /> Your data is secured with 256-bit encryption</Typography>
                    </Grid>
                </Grid>
            </form>
        </Box>
    </>)
}


export default Signup;